import { IContact } from 'clickNgo/entities/contact'

export const getDefaultReplacementContact = (contact: IContact): Partial<IContact> => ({
  // Preserve the current contact identity so the creator flow updates
  // the existing contact/375 row instead of creating a new one.
  contactId: contact.contactId,
  country: contact.country,
  countryOfBusiness: contact.countryOfBusiness,
  entryId: contact.entryId,
  entryId375: contact.entryId375,
  entryId379: contact.entryId379,
  hpRoles: contact.hpRoles,
  //market: normalizeMarket(contact.market),
  onboardingRequestId: contact.onboardingRequestId,
  parentPartnerId: contact.parentPartnerId,
  partnerId: contact.partnerId,
  preferredLanguage: contact.preferredLanguage,
  region: contact.region,
  source: contact.source,
  topPartnerId: contact.topPartnerId,
  workflowStatus: contact.workflowStatus,
})
